export default __webpack_public_path__ + "static/star-meshery-11fe5055095c18d042976624ff467f1c.png";